module.exports = __webpack_public_path__ + "img/renta.14939d5d.svg";